<template>
  <el-card
    class="box-card"
    shadow="never"
  >
    <div
      slot="header"
      class="clearfix"
    >
      <span style="color:#1c6f6e;font-size: 16px;font-weight: bold;">我的工单</span>
      <el-button
        style="float: right; padding: 8px 10px;"
        type="success"
        size="medium"
        @click="createWordOrder"
      >提交工单</el-button>
    </div>
    <div>
      <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="审批人">
          <el-input v-model="formInline.user" placeholder="审批人"></el-input>
        </el-form-item>
        <el-form-item label="活动区域">
          <el-select v-model="formInline.region" placeholder="活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form> -->
    </div>

    <el-table
      :data="tableList"
      v-loading="tableLoading"
      style="width: 100%; min-height: 300px"
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ background: '#F5F5F5', textAlign: 'center' }"
    >
      <el-table-column
        prop="workOrderId"
        label="工单标号"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="woTitle"
        label="工单标题"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="createdTime"
        label="创建时间"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="status"
        label="工单状态"
        width="160"
      >
        <template slot-scope="scope">
          <!-- <span>{{scope.row.status}}</span> -->
          <span>{{getStatusText(scope.row.status)}}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="300"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)"
            :style="{marginRight: '20px'}"
            :disabled="scope.row.status == 3"
          >回复</el-button>
          <el-button
            size="mini"
            slot="reference"
            type="primary"
            @click="handleLook(scope.row)"
            :style="{marginRight: '20px'}"
          >查看</el-button>
          <el-button
            size="mini"
            slot="reference"
            type="primary"
            @click="close(scope.row)"
            :disabled="scope.row.status == 3"
          >关闭</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-box">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageObj.pageIndex"
        :total="total"
        :page-size="pageObj.pageSize"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查看回复"
      :visible.sync="lookVisible"
      width="800px"
      :before-close="() => lookVisible = false"
    >

      <el-table
        :data="applyList"
        v-loading="applyTableLoading"
        style="width: 100%; min-height: 300px"
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{ background: '#F5F5F5', textAlign: 'center' }"
      >
        <el-table-column
          prop="replyUserName"
          label="回复人"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="replyContent"
          label="回复内容"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="createdTime"
          label="回复时间"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button size="mini" slot="reference" type="primary"  @click="deleteReply(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination-box">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="applyPageObj.pageIndex"
          :total="applyTotal"
          :page-size="applyPageObj.pageSize"
          @current-change="applyPageChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="回复"
      :visible.sync="visible"
      width="600px"
    >
      <div>
        <div :style="{marginBottom: '20px', marginLeft: '10px'}">工单标题：{{activeRow? activeRow.woTitle : ''}}</div>
        <el-form
          ref="replyForm"
          :model="replyForm"
          label-width="80px"
          :rules="replyRules"
        >
          <el-form-item
            label="回复内容"
            prop="replyContent"
          >
            <el-input
              type="textarea"
              v-model="replyForm.replyContent"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="onReplySubmit"
            >回复</el-button>
            <el-button
              size="small"
              @click="visible = false"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </div>

    </el-dialog>

    <el-dialog
      title="提交服务单"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          :rules="rules"
        >
          <el-form-item
            label="类型"
            prop="woType"
          >
            <el-select
              v-model="form.woType"
              placeholder="请选择工单类型"
            >
              <el-option
                v-for="(item, index) in workTypes"
                :key="index"
                :label="item.woTypeName"
                :value="item.woTypeCode"
              ></el-option>

            </el-select>
          </el-form-item>

          <el-form-item
            label="标题"
            prop="woTitle"
          >
            <el-input v-model="form.woTitle"></el-input>
          </el-form-item>

          <el-form-item
            label="内容"
            prop="woDesc"
          >
            <el-input
              type="textarea"
              v-model="form.woDesc"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="onSubmit"
            >立即创建</el-button>
            <el-button
              size="small"
              @click="dialogVisible = false"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

  </el-card>
</template>

<script>
import {
  queryWorkList,
  queryAllWorkType,
  createWork,
  queryReplyWork,
  createApply,
  deleteReply,
  deleteWordOrder,
} from '@/api/extra';

export default {
  data() {
    return {
      pageObj: {
        pageSize: 10,
        pageNum: 1,
      },
      applyPageObj: {
        pageSize: 10,
        pageNum: 1,
      },
      activeRow: null,
      applyTotal: 0,
      applyList: [],
      workTypes: [],
      total: 0,
      tableList: [],
      visible: false,
      tableLoading: false,
      applyTableLoading: false,
      lookVisible: false,
      dialogVisible: false,
      replyForm: {
        replyContent: '',
      },
      form: {
        woTitle: '',
        woType: '',
        woDesc: '',
      },
      list: null,
      listLoading: true,
      replyRules: {
        replyContent: [
          { required: true, message: '请填写内容', trigger: 'blur' },
        ],
      },
      rules: {
        woTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        woType: [
          { required: true, message: '请选择工单类型', trigger: 'change' },
        ],
        woDesc: [{ required: true, message: '请填写内容', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.fetchData();
    queryAllWorkType().then((res) => {
      if (res && res.code === 200) {
        this.workTypes = res.data;
      }
    });
  },
  methods: {
    getStatusText(status) {
      switch (status) {
        case 1:
          return '待处理';
        case 2:
          return '回复中';
        case 3:
          return '已关闭';
      }
    },
    pageChange(pageIndex) {
      this.pageObj = Object.assign({}, this.pageObj, { pageIndex });
    },
    applyPageChange(pageIndex) {
      this.applyPageObj = Object.assign({}, this.applyPageObj, { pageIndex });
    },

    createWordOrder() {
      this.dialogVisible = true;
    },

    deleteReply(row) {
      this.$confirm('确定要执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteReply({ woReplyId: row.woReplyId }).then((res) => {
            if (res && res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.applyTableLoading = true;
              queryReplyWork({
                workOrderId: row.workOrderId,
                ...this.applyPageObj,
              }).then((res) => {
                if (res && res.code === 200) {
                  this.applyList = res.data.list;
                  this.applyTableLoading = false;
                }
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    onReplySubmit() {
      this.$refs['replyForm'].validate((valid) => {
        if (valid) {
          createApply({
            ...this.replyForm,
            workOrderId: this.activeRow.workOrderId,
          }).then((res) => {
            if (res && res.code === 200) {
              this.visible = false;
          
              this.replyForm.replyContent = '';
              this.activeRow = null;
            }
          });
        }
      });
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let woTypeDesc;
          this.workTypes.forEach((i) => {
            if (this.form.woType === i.woTypeCode) {
              woTypeDesc = i.woTypeName;
            }
          });
          createWork({ ...this.form, status: 1, woTypeDesc }).then((res) => {
            if (res && res.code === 200) {
              this.dialogVisible = false;
              this.fetchData();
            }
          });
        }
      });
    },
    goDetail(row) {
      this.$router.push(`/resource/list/detail/${row.id}`);
    },
    handleLook(row) {
      this.lookVisible = true;
      this.applyTableLoading = true;
      queryReplyWork({
        workOrderId: row.workOrderId,
        ...this.applyPageObj,
      }).then((res) => {
        if (res && res.code === 200) {
          this.applyList = res.data.list;
          this.applyTableLoading = false;
        }
      });
    },
    close(row) {
      this.$confirm('确定要执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteWordOrder({ workOrderId: row.workOrderId }).then((res) => {
            if (res && res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!',
              });
              this.fetchData();
            }
          });
        })
    },
    handleEdit(row) {
      this.visible = true;
      this.activeRow = row;
    },
    fetchData() {
      this.tableLoading = true;
      queryWorkList(this.pageObj).then((res) => {
        this.tableList = res.data.list;
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.box-card {
  margin-bottom: 10px;
  border: none;
}
.pagination-box {
  padding: 30px 20px;
  text-align: right;
}
.t {
  text-align: center;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1c6f6e;
        color: #FFF !important;
    }
    /deep/.el-pager li:hover {
        color: #1c6f6e !important;
    }
</style>
